// Get take off settings by icao code.
export const getTkofSettingsByIcao = (icao, adList) => {
    if (!icao || !adList || adList.length == 0) return undefined;
  
    for (const tkof of adList) {
        const code = tkof.split(';')[0];
        if (code === icao) {
            return tkof;
        }
    }
    return undefined; 
  }